import React from "react";
import { NavLink , useNavigate} from "react-router-dom";
import styled from "styled-components";

const ManagerSideBar = (props) => {
  const navigate = useNavigate();
  // const logout = props.logOut;

  const userType = sessionStorage.getItem('role') === 'Admin'

  return (
    <aside
      className="sidenav navbar navbar-vertical navbar-expand-xs border-0 border-radius-xl my-3 fixed-start ms-3   bg-gradient-dark"
      id="sidenav-main"
    >
      <div className="sidenav-header bg-white">
        <div className="d-flex justify-content-center align-items-center">
        <a
          className="navbar-brand m-0"
          href="https://playstream.media/"
        >
          <img
            src="../assets/img/Playstream-icon.png"
            className="navbar-brand-img h-100"
            alt="main_logo_not_found"
          />
          {/* <span className="ms-1 font-weight-bold text-white">PlayStream Dashboard</span> */}
        </a>
      </div>
      </div>
      <hr className="horizontal light mt-0 mb-2" />
      <div

        id="sidenav-collapse-main"
      >
        <ul className="navbar-nav">
          <li className="nav-item">
            <StyledNavLink
              className="nav-link text-white"
              to="/dashboard"
              exact
              activeclassName="active"
              isActive={(match, location) => {
                if (match) {
                  return true;
                } else {
                  return false;
                }
              }}
            >
              <div className="text-white text-center me-2 d-flex align-items-center justify-content-center">
                <i className="material-icons opacity-10">dashboard</i>
              </div>
              <span className="nav-link-text ms-1">Dashboard</span>
            </StyledNavLink>
          </li>
          {
            userType && (
              <li className="nav-item">
                <StyledNavLink
                  className="nav-link text-white"
                  to="/logs"
                  exact
                  activeclassName="active"
                  isActive={(match, location) => {
                    if (match) {
                      return true;
                    } else {
                      return false;
                    }
                  }}
                >
                  <div className="text-white text-center me-2 d-flex align-items-center justify-content-center">
                    <i className="material-icons opacity-10">dashboard</i>
                  </div>
                  <span className="nav-link-text ms-1">Logs</span>
                </StyledNavLink>
              </li>

            )
          }
          {
            userType && (
              <li className="nav-item">
                <StyledNavLink
                  className="nav-link text-white"
                  to="/users"
                  exact
                  activeclassName="active"
                  isActive={(match, location) => {
                    if (match) {
                      return true;
                    } else {
                      return false;
                    }
                  }}
                >
                  <div className="text-white text-center me-2 d-flex align-items-center justify-content-center">
                    <i className="material-icons opacity-10">dashboard</i>
                  </div>
                  <span className="nav-link-text ms-1">Users</span>
                </StyledNavLink>
              </li>

            )
          }
          {
            userType && (
              <>

                <li className="nav-item mt-3">
                  <h6 className="ps-4 ms-2 text-uppercase text-xs text-white font-weight-bolder opacity-8">
                    Admin Rights
                  </h6>
                </li>


                <li className="nav-item">
                  <a
                    className="nav-link text-white "
                    onClick={(e) => navigate("/makeJSON")}
                  >
                    <div className="text-white text-center me-2 d-flex align-items-center justify-content-center">
                      <i className="material-icons opacity-10">assignment</i>
                    </div>
                    <span className="nav-link-text ms-1">Bulk Upload</span>
                  </a>
                </li>
              </>

            )}

        </ul>
      </div>
    </aside>
  );
};

const StyledNavLink = styled(NavLink)`
  &.active {
    background-color: #49a3f1 !important;
  }
`;

export default ManagerSideBar;
